import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"

import { FirebaseAppProvider } from "reactfire"
import { ChakraProvider, extendTheme } from "@chakra-ui/react"

// Admin pages
import AdminConfigurationPage from "./pages/Admin/ConfigurationPage"
import AdminLinksPage from "./pages/Admin/LinksPage"
import AdminOrderPage from "./pages/Admin/OrderPage"
import AdminOrdersPage from "./pages/Admin/OrdersPage"
import AdminOrdersPivotPage from "./pages/Admin/OrdersPivotPage"
import AdminOrdersPivotZonePage from "./pages/Admin/OrdersPivotZonePage"
import AdminPrintAllPage from "./pages/Admin/PrintAllPage"
import AdminPrintByZonePage from "./pages/Admin/PrintByZonePage"
import AdminPrintPage from "./pages/Admin/PrintPage"
import AdminProductsPage from "./pages/Admin/ProductsPage"
// Shop pages
import ShopLinkPage from "./pages/Shop/LinkPage"
import ShopHomePage from "./pages/Shop/HomePage"
import ShopSuccessPage from "./pages/Shop/SuccessPage"

const theme = extendTheme({
  colors: {
    sidebar: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
    brand: {
      50: "#E6FFFA",
      100: "#B2F5EA",
      200: "#81E6D9",
      300: "#4FD1C5",
      400: "#38B2AC",
      500: "#319795",
      600: "#2C7A7B",
      700: "#285E61",
      800: "#234E52",
      900: "#1D4044",
    },
  },
})

const firebaseConfig = {
  apiKey: "AIzaSyAb2NOpJYSRq2b-ByocFRJg-xvHXuHf_98",
  authDomain: "agrifood-loghino.firebaseapp.com",
  projectId: "agrifood-loghino",
  storageBucket: "agrifood-loghino.appspot.com",
  messagingSenderId: "346159178641",
  appId: "1:346159178641:web:d70cd111b712d5e775f030",
}

const App = () => (
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <ChakraProvider theme={theme}>
        <Router>
          <Switch>
            <Route path="/admin/ordini/verticale/:linkId">
              <AdminOrdersPivotPage />
            </Route>
            <Route path="/admin/ordini/verticale_zone/:linkId">
              <AdminOrdersPivotZonePage />
            </Route>
            <Route path="/admin/ordini/:linkId/:orderId">
              <AdminOrderPage />
            </Route>
            <Route path="/admin/ordini/:linkId/">
              <AdminOrdersPage />
            </Route>
            <Route path="/admin/ordini">
              <AdminLinksPage />
            </Route>
            <Route path="/admin/cartellini/:linkId/:category/:orderId">
              <AdminPrintPage />
            </Route>
            <Route path="/admin/cartellini/:linkId/:category">
              <AdminPrintAllPage />
            </Route>
            <Route path="/admin/cartellini_zone/:linkId">
              <AdminPrintByZonePage />
            </Route>
            <Route path="/admin/inventario">
              <AdminProductsPage />
            </Route>
            <Route path="/admin/comuni">
              <AdminConfigurationPage />
            </Route>
            <Route path="/admin">
              <AdminLinksPage />
            </Route>

            <Route path="/conferma/:orderId">
              <ShopSuccessPage />
            </Route>
            <Route path="/:linkId">
              <ShopLinkPage />
            </Route>
            <Route path="/">
              <ShopHomePage />
            </Route>
          </Switch>
        </Router>
      </ChakraProvider>
    </FirebaseAppProvider>
  </React.StrictMode>
)

ReactDOM.render(<App />, document.getElementById("root"))
